export default {
  props: {
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
     // 组件创建方式
    isNewCreationMode() {
      return this.$route.query.creationMode == 'new'
    }
  },
  data() {
    return {}
  },
  methods: {
    jumpDetail(goods) {
      if (this.isNewCreationMode) return
      this.$router.push({
        path: '/group-detail',
        query: goods
      })
    }
  }
}